<template>
  <div class="bg-grey-50 flex flex-col gap-1.5 p-2 rounded-lg">
    <div class="flex items-start w-full">
      <p class="flex-1 text-xs text-grey-600 leading-5 m-0">
        Please note
      </p>
    </div>

    <div class="flex flex-col gap-1 w-full">
      <div
        v-for="(restriction, index) in restrictions"
        :key="index"
        class="flex gap-2 items-center w-full"
      >
        <SlashCircleIcon
          class="w-3 h-3 text-grey-600 shrink-0"
        />

        <p class="flex-1 text-xs text-grey-800 leading-4 tracking-[0.2px] m-0">
          {{ restriction }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import SlashCircleIcon from '@tagvenue/icons/24/bold/general/slash-circle-01.svg';
import { onMounted } from 'vue';
import { useStore } from 'vuex';

defineProps({
  restrictions: {
    type: Array,
    required: true,
    validator: (value) => value.every((item) => typeof item === 'string'),
  },
});

const store = useStore();

onMounted(() => {
  store.dispatch('trackGA4Interaction', {
    section: 'event_info',
    element: 'restrictions_info',
    interaction: 'visible',
  });
});
</script>
